import { RefObject } from 'react';
import ConversationMessages from './ConversationMessages.tsx';
import { Message } from '../../types';

export type ConversationsMessageThreadProps = {
  messages: Message[];
  messagesEndRef: RefObject<HTMLDivElement>;
  onImprove: (message: Message) => void;
  onTeachResponse: (message: Message) => void;
  unreadCount?: number;
};

export default function ConversationsMessageThread({
  messages,
  messagesEndRef,
  onImprove,
  onTeachResponse,
  unreadCount,
}: ConversationsMessageThreadProps) {
  return (
    <div
      className="flex-1 min-h-0 overflow-y-auto p-4"
      style={{
        backgroundColor: '#fffbf5',
        backgroundImage: "linear-gradient(rgba(255, 251, 245, 0.76), rgba(255, 251, 245, 0.76)), url('/background3.png')",
        backgroundSize: 'auto, 200px auto',
        backgroundRepeat: 'repeat',
      }}
    >
      <div className="space-y-3">
        {messages.length === 0 && (
          <p className="text-center text-gray-500 py-4">
            Nenhuma mensagem para exibir.
          </p>
        )}
        <ConversationMessages
          messages={messages}
          messagesEndRef={messagesEndRef}
          onImprove={onImprove}
          onTeachResponse={onTeachResponse}
          unreadCount={unreadCount}
          unreadSeparatorMarginClassName="-mx-4"
          messageContainerClassName="mx-auto w-full max-w-[1600px] md:w-[90%] xl:w-[94%]"
        />
      </div>
    </div>
  );
}
